module.exports = __webpack_public_path__ + "img/phoenix_kedel_2.a3b8bdf7.png";